import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📚 MasterPack Marca Propia Argentina (12 Tomos)',
  price: '$19.990'
}, {
  label: '🎁 Calculadora Inflación-Proof de Costos',
  price: 'GRATIS'
}, {
  label: '🎁 Filtro de Oro para Proveedores',
  price: 'GRATIS'
}, {
  label: '🎁 Reporte 30 Nichos Ganadores 2026',
  price: 'GRATIS'
}, {
  label: '🎁 Scripts de Venta Cierre Inmediato',
  price: 'GRATIS'
}, {
  label: '🎁 Radar Viral de Reels y TikTok',
  price: 'GRATIS'
}, {
  label: '🛡️ Garantía 7 días',
  price: 'INCLUIDA'
}];
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago · Tarjeta'
}];
export function ValueStack() {
  return <section id="value" aria-label="Resumen de la oferta" className="border-y border-white/5 bg-ink-2" data-id="element-185" data-mp="35pd4rm7gorhs">
      <div className="mx-auto max-w-2xl px-5 pt-[32px] pb-[21px] text-center" style={{
      paddingTop: "9px"
    }} data-id="element-186" data-mp="1tfwdkbm2tw8m">
        <h2 className="font-display text-2xl font-black text-white sm:text-4xl" data-id="element-187" data-mp="1oi3a3qc5rgc1">
          🚀 Lanzá tu marca hoy
        </h2>
        <p className="mt-3 text-sm text-white/60" style={{
        paddingTop: "22px",
        marginTop: "-20px",
        marginBottom: "-20px"
      }} data-id="element-188" data-mp="1yeg2mkvyvo57">
          Un pago único. Acceso de por vida. Sistema listo para aplicar en minutos.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-white/10 bg-ink text-left" data-id="element-189" data-mp="284slm8o4v998">
          <div className="flex items-center justify-between border-b border-white/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-white/50" style={{
          paddingTop: "0px",
          marginTop: "-15px",
          marginBottom: "-15px"
        }} data-id="element-190" data-mp="2m4k34jduz7rz">
            <span data-id="element-191" data-mp="rqsof5go9xpo">Qué incluye</span>
            <span data-id="element-192" data-mp="rrubk8ayqanr">Precio</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-white/5 px-5 py-3.5 text-sm" style={{
          paddingTop: "1px",
          paddingBottom: "13px"
        }} data-id="element-193" data-mp="ms7wrufhkmcu">
              <span className="text-white/80" style={{
            paddingTop: "4px"
          }} data-id="element-194" data-mp="2rrh6lb8ogveg">{r.label}</span>
              <span className={r.price.startsWith('$') ? 'shrink-0 font-bold text-white' : 'shrink-0 font-bold text-gold'} data-id="element-195" data-mp="2vtkqmo9ex8bc">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-wrap items-center justify-between gap-2 bg-celeste/10 px-5 py-4" style={{
          paddingTop: "4px",
          paddingBottom: "0px"
        }} data-id="element-196" data-mp="35sjt1p3l47pw">
            <span className="text-sm font-bold text-white" style={{
            textAlign: "center"
          }} data-id="element-197" data-mp="3aos52tmhjksu">
              Valor total real: <span className="text-white/40 line-through" data-id="element-198" data-mp="3jj6rdg5fnvlg">$101.940</span>
            </span>
            <span className="font-display text-2xl font-black text-gold-shine" style={{
            textAlign: "center"
          }} data-id="element-199" data-mp="3oije80wb12o1">$19.990 ARS</span>
          </div>
        </div>

        <div className="mt-9" style={{
        paddingTop: "14px",
        marginTop: "-5px",
        marginBottom: "-5px"
      }} data-id="element-200" data-mp="3ti4bm6vtt2yn">
          <CTAButton data-id="element-201" data-mp="7hq7zdowupni">Sí, quiero lanzar mi marca de ropa</CTAButton>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-202" data-mp="2g0za4p5uo2l">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-203" data-mp="3pma2k2rk3fjx">
              <Icon className="h-4 w-4 text-gold" data-id="element-204" data-mp="q6n1hfchhe4o" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}